import { render, staticRenderFns } from "./PriceWorkflowExportModal.vue?vue&type=template&id=48ac65e7&scoped=true&"
import script from "./PriceWorkflowExportModal.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowExportModal.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowExportModal.vue?vue&type=style&index=0&id=48ac65e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ac65e7",
  null
  
)

export default component.exports